export default {
    // 八大神校
    offerList: {
        "Harvard": {
            cate: "Harvard",
            count: "23",
            image: "20220404074805.jpg",
            list: [
                {
                    "title": "哈佛大学全奖博士！绩点普通的我拿到了！",
                    "link": "https://mp.weixin.qq.com/s/Jvz5ytkdF2WqPgLg44gNJQ",
                    "serial_number": 1
                },
                {
                    "title": "火热：Harvard应用数学全奖offer！来自上海！",
                    "link": "https://mp.weixin.qq.com/s/yqhrXesk6QlQ_Y5XtBmq0g",
                    "serial_number": 1
                },
                {
                    "title": "情人节礼物：哈佛DS，来自【上纽大】！",
                    "link": "https://mp.weixin.qq.com/s/dpzyKicSiGp4oCGuiLV2hw",
                    "serial_number": 1
                },
                {
                    "title": "哈佛大学热门offer，感谢世毕盟！",
                    "link": "https://mp.weixin.qq.com/s/_UK0BjlEXx800cOOpCXXtA",
                    "serial_number": 1
                },
                {
                    "title": "继续横扫，Harvard数据科学offer来啦！波士顿见！",
                    "link": "https://mp.weixin.qq.com/s/_W6VQX5PKb4yTarVrkt7jA",
                    "serial_number": 1
                },
                {
                    "title": "如愿以偿：Harvard DS抵达！2026冲！",
                    "link": "https://mp.weixin.qq.com/s/uJ8tl8-lLxg0guR0v-BFxA",
                    "serial_number": 1
                },
                {
                    "title": "哥大不要了，哈佛大学offer来了！我去波士顿！",
                    "link": "https://mp.weixin.qq.com/s/d7yDQ8R2gn2jxGxwR2anwA",
                    "serial_number": 1
                },
                {
                    "title": "哈佛大学DS+1，来自【北京】！",
                    "link": "https://mp.weixin.qq.com/s/CGb4NCvZbEgpP43MPFBNdw",
                    "serial_number": 1
                },
                {
                    "title": "顺手一申，Harvard DS录取信就到啦！2026 FALL！",
                    "link": "https://mp.weixin.qq.com/s/36lPW4BPUPESfVWS4v9ZOw",
                    "serial_number": 1
                },
                {
                    "title": "0实习，Harvard热门offer抵达！波士顿见！",
                    "link": "https://mp.weixin.qq.com/s/rUChJ2S0MhpON-kVOuWfJA",
                    "serial_number": 1
                },
                {
                    "title": "好激动，哈佛大学热门offer！2026秋见！",
                    "link": "https://mp.weixin.qq.com/s/FRJmJDWzWmcIkg3pw1Fgnw",
                    "serial_number": 1
                },
                {
                    "title": "申请基本结束：Harvard录取来了，波士顿见！",
                    "link": "https://mp.weixin.qq.com/s/Xn0kObi1xl2Oy4VqVkQlTQ",
                    "serial_number": 1
                },
                {
                    "title": "啊啊啊，我要晕倒，是哈佛大学offer！",
                    "link": "https://mp.weixin.qq.com/s/8Yfl8VLUInKYXZrB_eEwCQ",
                    "serial_number": 1
                },
                {
                    "title": "没错，哈佛大学offer，2026入学！",
                    "link": "https://mp.weixin.qq.com/s/oIGXPMJlXKp8TYa0GCbdvw",
                    "serial_number": 1
                },
                {
                    "title": "Harvard生物统计offer，2026年波士顿见！",
                    "link": "https://mp.weixin.qq.com/s/8AEAglkX4MwPqrguIyTY6w",
                    "serial_number": 1
                },
                {
                    "title": "虽然不去，但是Harvard的offer还是来啦！2026！",
                    "link": "https://mp.weixin.qq.com/s/-FwDFsTHApmzqXIa0M-LBA",
                    "serial_number": 1
                },
                {
                    "title": "Harvard DS+1，意外收获！来自【中山大学】！",
                    "link": "https://mp.weixin.qq.com/s/zb2ilq4K7FTBL9H18aw3VA",
                    "serial_number": 1
                },
                {
                    "title": "托福没考，GRE没考，Harvard录取来啦！！！",
                    "link": "https://mp.weixin.qq.com/s/RkgQZBcFDfS3lbivhaZmrA",
                    "serial_number": 1
                },
                {
                    "title": "虽然不去，但是Harvard offer还是来啦！",
                    "link": "https://mp.weixin.qq.com/s/GIOy0KepZUZFEQHWxABlew",
                    "serial_number": 1
                },
                {
                    "title": "哈佛大学录取，来自【中国香港】！",
                    "link": "https://mp.weixin.qq.com/s/rT4SjXRiL07W2Jg2dk6u8w",
                    "serial_number": 1
                },
                {
                    "title": "稳得很，Harvard录取来啦！波士顿见！",
                    "link": "https://mp.weixin.qq.com/s/lMcMXemdJSuCtepZl5WGeQ",
                    "serial_number": 1
                },
                {
                    "title": "哈佛大学统计博士全奖offer，2学员集体斩获！2026见！",
                    "link": "https://mp.weixin.qq.com/s/SNdbVAD1NjChQuWeSOcnQQ",
                    "serial_number": 2
                }
            ]
        },
        "MIT": {
            cate: "MIT",
            count: "11",
            image: "20220414053442.jpg",
            list: [
                {
                    "title": "MIT商业分析，6学员集体斩获！2026波士顿见！",
                    "link": "https://mp.weixin.qq.com/s/WCxHc74Mx3fe0AA7EnruPA",
                    "serial_number": 6
                },
                {
                    "title": "MIT金融学，5学员集体收获！波士顿见！",
                    "link": "https://mp.weixin.qq.com/s/a11LMQVfqx4vAjYPxGtHLg",
                    "serial_number": 5
                }
            ]
        },
        "Princeton": {
            cate: "Princeton",
            count: "9",
            image: "20220507105046.jpg",
            list: [
                {
                    "title": "火热：普林斯顿大学，全额奖学金offer，抵达！",
                    "link": "https://mp.weixin.qq.com/s/ynZqulxd0g6JgrsIULQ9pA",
                    "serial_number": 1
                },
                {
                    "title": "迎财神，迎offer！Princeton ORFE全奖博士到！",
                    "link": "https://mp.weixin.qq.com/s/gXWAs_42_yh6_qLe0AViow",
                    "serial_number": 1
                },
                {
                    "title": "Princeton运筹与金融工程，博士全奖，2学员集体收获！！！",
                    "link": "https://mp.weixin.qq.com/s/gZgCbK4ZeiV3uufcDJmkqw",
                    "serial_number": 2
                },
                {
                    "title": "Princeton金融，4学员集体收获！2026王子屯见！",
                    "link": "https://mp.weixin.qq.com/s/mrRlVtPT7vbJDNHTMiOZlQ",
                    "serial_number": 4
                },
                {
                    "title": "普林斯顿大学，公共事务全奖博士offer！2026王子屯见！",
                    "link": "https://mp.weixin.qq.com/s/8ic5sFJqkhdUIcgZO8slFQ",
                    "serial_number": 1
                }
            ]
        },
        "Stanford": {
            cate: "Stanford",
            count: "16",
            image: "20220402105830.jpg",
            list: [
                {
                    "title": "26Fall 申请季“闪电战”，一举锁定斯坦福 ！",
                    "link": "https://mp.weixin.qq.com/s/_R1yzGVvP3mJv3Tq2Rmb_A",
                    "serial_number": 1
                },
                {
                    "title": "凌晨3点多，斯坦福大学全奖offer，她来啦！2026 Palo Alto见！",
                    "link": "https://mp.weixin.qq.com/s/XzK_G_mDXtx-NCriLFQpog",
                    "serial_number": 1
                },
                {
                    "title": "老师！我收到一张Stanford的全奖offer，2026入学！",
                    "link": "https://mp.weixin.qq.com/s/VCYs3eNomYG7sLSi6-CmEQ",
                    "serial_number": 1
                },
                {
                    "title": "爆：Stanford商学院博士全奖！2026秋天见！",
                    "link": "https://mp.weixin.qq.com/s/sJF534HaSgevnrxnMXpyHw",
                    "serial_number": 1
                },
                {
                    "title": "来吧：Stanford统计学offer，2026我来啦！",
                    "link": "https://mp.weixin.qq.com/s/6VP6ZUKB6krBcU-h7N0RkA",
                    "serial_number": 1
                },
                {
                    "title": "元宵节礼物：Stanford统计学offer！2026入学！",
                    "link": "https://mp.weixin.qq.com/s/3fdXoeBM5qTuSvWj1P4MAQ",
                    "serial_number": 1
                },
                {
                    "title": "哇：Stanford MS&E录取，2026见！",
                    "link": "https://mp.weixin.qq.com/s/1bdFATbyGHXj5nNPuC1EfQ",
                    "serial_number": 1
                },
                {
                    "title": "Stanford MS&E+1，2026 Palo Alto见！",
                    "link": "https://mp.weixin.qq.com/s/_j0S9-NlWVIXtLlyIGBnog",
                    "serial_number": 1
                },
                {
                    "title": "哇！斯坦福大学录取我啦！感谢世毕盟！",
                    "link": "https://mp.weixin.qq.com/s/5bokGJ5To5_B_lkICinOtA",
                    "serial_number": 1
                },
                {
                    "title": "哇，Stanford录取我啦！2026秋天见！",
                    "link": "https://mp.weixin.qq.com/s/VAHj_6cu-vkQzBN8h3hvfw",
                    "serial_number": 1
                },
                {
                    "title": "第3枚Stanford统计offer，来自【上海财经】！！！",
                    "link": "https://mp.weixin.qq.com/s/57HCPVEpppKrh-Xjfd_r9Q",
                    "serial_number": 1
                },
                {
                    "title": "Finally！斯坦福博士全奖录取！终于来了！",
                    "link": "https://mp.weixin.qq.com/s/Ekp7gJUmPKD-NUyneqQ-IQ",
                    "serial_number": 1
                },
                {
                    "title": "GRE无，托福无，Stanford录取啦！！！",
                    "link": "https://mp.weixin.qq.com/s/LAq1h2Tij06-xegmqw1TjA",
                    "serial_number": 1
                },
                {
                    "title": "三月来信！斯坦福大学offer！相约Palo Alto！",
                    "link": "https://mp.weixin.qq.com/s/BhxbMA1-z7Bh3JklRF8E3A",
                    "serial_number": 1
                },
                {
                    "title": "斯坦福大学CS offer，2026入学！九月见！",
                    "link": "https://mp.weixin.qq.com/s/dUMisbMhUiGnO0RN_DLF3Q",
                    "serial_number": 1
                },
                {
                    "title": "尘埃落定：Stanford CS博士全奖！2026秋季见！",
                    "link": "https://mp.weixin.qq.com/s/-N_Ph-wJDPSHPOqTIke2kQ",
                    "serial_number": 1
                }
            ]
        },
        "Berkeley": {
            cate: "Berkeley",
            count: "41",
            image: "20220704111303.png",
            list: [
                {
                    "title": "Berkeley offer，速度下offer，我来啦！2026！",
                    "link": "https://mp.weixin.qq.com/s/6zrLzex3WUaPvWkS1att2g",
                    "serial_number": 1
                },
                {
                    "title": "热：Berkeley offer，8万美元奖学金！2026入学！！！",
                    "link": "https://mp.weixin.qq.com/s/A96Ijgmr6bMOerDakXxRTQ",
                    "serial_number": 1
                },
                {
                    "title": "逆袭：GPA中游，Berkeley EECS全奖来啦！",
                    "link": "https://mp.weixin.qq.com/s/VN-oJayYcUdfZiyKrJKRBw",
                    "serial_number": 1
                },
                {
                    "title": "UC Berkeley EECS 全奖博士录取！来自【北大】",
                    "link": "https://mp.weixin.qq.com/s/UfvzaGBxOtxJjpjUoJj9VQ",
                    "serial_number": 1
                },
                {
                    "title": "行业金字塔：UC Berkeley录取！来自【北京】！",
                    "link": "https://mp.weixin.qq.com/s/M9P9xafNPNamDCNsYygAvQ",
                    "serial_number": 1
                },
                {
                    "title": "早上收到：Berkeley热门offer！2026！",
                    "link": "https://mp.weixin.qq.com/s/7z8QuF8icuQwAMzMV5_ZyA",
                    "serial_number": 1
                },
                {
                    "title": "UC Berkeley热门offer，来自【西交利物浦】！",
                    "link": "https://mp.weixin.qq.com/s/0K6MWXufiTistURNf65uYg",
                    "serial_number": 1
                },
                {
                    "title": "我不知所措了：UC Berkeley全奖offer！2026！",
                    "link": "https://mp.weixin.qq.com/s/-ufC5IkSvN5hejEWRK43uw",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley热门offer抵达：来自香港！",
                    "link": "https://mp.weixin.qq.com/s/fzYvpBbQSMyHSuayYoc_CA",
                    "serial_number": 1
                },
                {
                    "title": "加州爱我！Berkeley金融科技offer来啦！",
                    "link": "https://mp.weixin.qq.com/s/QGrTB6StMWyaTMsLtf2QhQ",
                    "serial_number": 1
                },
                {
                    "title": "UC Berkeley热门ofer，来自【中科大】！",
                    "link": "https://mp.weixin.qq.com/s/XzLa0gdKJdGDUnk_k2Ai2g",
                    "serial_number": 1
                },
                {
                    "title": "它来了它来了！伯克利全奖博士终于来了！",
                    "link": "https://mp.weixin.qq.com/s/yTIXz2mZidXYl_s4zNK89w",
                    "serial_number": 1
                },
                {
                    "title": "难，太难了！从中科大到伯克利，2026 秋季见！",
                    "link": "https://mp.weixin.qq.com/s/8NAsjjAJc7UO3TW7IKH9IA",
                    "serial_number": 1
                },
                {
                    "title": "爆发：Berkeley商学院全奖博士offer！2026秋天见！",
                    "link": "https://mp.weixin.qq.com/s/b0HRv0ws18m_09KPzGUpLw",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley统计offer，来自【四川大学】！！！！",
                    "link": "https://mp.weixin.qq.com/s/LGniFrTscBiHpfw1dYZykw",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley统计与数据科学offer，来自【华师】！",
                    "link": "https://mp.weixin.qq.com/s/XaSxjWW6Sko82jPCKvv2Ig",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley材料科学与工程offer，2026秋天见！",
                    "link": "https://mp.weixin.qq.com/s/K_LdBQ92KQsuMMjoRQtFDA",
                    "serial_number": 1
                },
                {
                    "title": "刚刚收到，Berkeley材料offer！来自【华理】！",
                    "link": "https://mp.weixin.qq.com/s/_5oyZGsAllLmYhecsdLybQ",
                    "serial_number": 1
                },
                {
                    "title": "加州伯克利！专排Top3，土木与环境工程录取！",
                    "link": "https://mp.weixin.qq.com/s/tCYIh99zj8Kbyn1BDSgQCg",
                    "serial_number": 1
                },
                {
                    "title": "从华科出发！心心念念的伯克利我来了！",
                    "link": "https://mp.weixin.qq.com/s/L98Ope-OFx0du5zetUaC8A",
                    "serial_number": 1
                },
                {
                    "title": "UC Berkeley分析学，10学员集体收获！2026！",
                    "link": "https://mp.weixin.qq.com/s/sBY4PMwUVT3PcW6OjNWsxA",
                    "serial_number": 10
                },
                {
                    "title": "Berkeley EECS录取，来自【西交利物浦】！",
                    "link": "https://mp.weixin.qq.com/s/toJDOoDn1-Ssjww65Oa5Ng",
                    "serial_number": 1
                },
                {
                    "title": "最后发offer：Berkeley全奖博士，2026入学！",
                    "link": "https://mp.weixin.qq.com/s/fu9k8qOnSC23CaHMYXlMYA",
                    "serial_number": 1
                },
                {
                    "title": "哈佛/耶鲁/牛津之后，Berkeley EECS也来啦！！！！",
                    "link": "https://mp.weixin.qq.com/s/5AfbZ8L-V5smcRT_m8nepg",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley金融科技offer，来自【上纽大】！",
                    "link": "https://mp.weixin.qq.com/s/DUdlaUow47fgJfMV8TucuA",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley机械工程offer，来自【中国澳门】！",
                    "link": "https://mp.weixin.qq.com/s/1I4nlSJRMWt6R23QM7oifQ",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley统计与数据科学offer，来自【加本】学员！",
                    "link": "https://mp.weixin.qq.com/s/8_PhsvvDhZ4llmhFV6vvKA",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley EECS，录取来自【上交】！2026！",
                    "link": "https://mp.weixin.qq.com/s/_H2IIIl92WIaq0n_mAB9Kw",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley分析学，第11枚！来自【上纽大】！",
                    "link": "https://mp.weixin.qq.com/s/esuHlxrlxTg0rFaJk-nOGw",
                    "serial_number": 1
                },
                {
                    "title": "兴奋：Berkeley统计与数据科学offer，2026！",
                    "link": "https://mp.weixin.qq.com/s/CNA5K1DnNxGBuVQHdYHrRA",
                    "serial_number": 1
                },
                {
                    "title": "伯克利带奖硕士到达！我要接录取！",
                    "link": "https://mp.weixin.qq.com/s/sP-X8oZ8OpA8W7cy8yQj-g",
                    "serial_number": 1
                },
                {
                    "title": "offer看漏了：UC Berkeley, 2026秋！",
                    "link": "https://mp.weixin.qq.com/s/afrPXi5eI2jAW3tIAb42hQ",
                    "serial_number": 1
                }
            ]
        },
        "CMU": {
            cate: "CMU",
            count: "98",
            image: "20220615102052.jpg",
            list: [
                {
                    "title": "热门：四大神校的offer到啦！2026入学！！！",
                    "link": "https://mp.weixin.qq.com/s/9JqlI4k3JBeY07BNEpwzgg",
                    "serial_number": 1
                },
                {
                    "title": "梦想：CMU录取！四大真的来了！2026入学！",
                    "link": "https://mp.weixin.qq.com/s/wUJ3ig8PSyKyzJNo1IjnFQ",
                    "serial_number": 1
                },
                {
                    "title": "高薪就业神器：CMU MCDS，五学员集体斩获！！！",
                    "link": "https://mp.weixin.qq.com/s/aoT387F88TzZyeqw73sOKQ",
                    "serial_number": 5
                },
                {
                    "title": "【捷报】CMU 机械工程博士全奖offer已到！恭喜海本学员！",
                    "link": "https://mp.weixin.qq.com/s/hcDh2sxUXmCxgzYryCo0sw",
                    "serial_number": 1
                },
                {
                    "title": "爆！全美Top 2商学院PhD offer今日抵达！",
                    "link": "https://mp.weixin.qq.com/s/PCTvaCPvnf6N-LCtQbwm5Q",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】高含金量热门项目！CMU 数据分析科学硕士录取来啦！",
                    "link": "https://mp.weixin.qq.com/s/IVmgHDH0PYdT8snD8Q-B4A",
                    "serial_number": 1
                },
                {
                    "title": "AI世界之巅：CMU LTI博士全奖offer抵达！！！",
                    "link": "https://mp.weixin.qq.com/s/0DZkkP8fMu8yKQQuokDkQA",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】机器人旗舰项目，CMU MSR offer来了！",
                    "link": "https://mp.weixin.qq.com/s/I0wgo-hada1CU9XZBE7WFQ",
                    "serial_number": 1
                },
                {
                    "title": "CS硕士天花板：CMU MSML，6学员集体收获！",
                    "link": "https://mp.weixin.qq.com/s/qlV9A2_Y93sVnEItPzFk_w",
                    "serial_number": 6
                },
                {
                    "title": "【捷报】CMU医疗交叉学科录取+1，恭喜美本学员！",
                    "link": "https://mp.weixin.qq.com/s/_U6ByNboPMA_Bb5r66wlBg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】机器人旗舰项目，CMU MSR offer再+2！",
                    "link": "https://mp.weixin.qq.com/s/CZuyCNyt69W1HsqkX1-EIQ",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】CMU商业智能与数据分析硕士！祝贺人大学员！",
                    "link": "https://mp.weixin.qq.com/s/bhBmcG250ZHlLYND4TE2iA",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】牛！CMU ECE录取到手！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/KAH3OIlIKu10h1XiR5XIkw",
                    "serial_number": 1
                },
                {
                    "title": "金工天花板：CMU MSCF，9学员集体斩获！！！",
                    "link": "https://mp.weixin.qq.com/s/gkYQCsThmJXEiytrPtI8Zw",
                    "serial_number": 9
                },
                {
                    "title": "【捷报】牛！CMU人工智能工程录取到手！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/WAdVDdKdRkTtzZfFjO6WEw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】恭喜！CMU BIDA录取+5！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/s4QcJxYJRFXiwzYRUY5RCg",
                    "serial_number": 5
                },
                {
                    "title": "【捷报】双录CMU！两名世毕盟学员斩获机械工程硕士offer！",
                    "link": "https://mp.weixin.qq.com/s/faSFy0aLEXfcKaE3Q1RlKQ",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】好消息！CMU MSPPM 录取来啦！",
                    "link": "https://mp.weixin.qq.com/s/bn8JNmAOfSYWpQpvAGLuGQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】实力见证！CMU哲学PhD Offer来了！",
                    "link": "https://mp.weixin.qq.com/s/H-BPwYkcO00OLF_XOKoWCQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】再添一枚：CMU王牌AI工程项目录取！",
                    "link": "https://mp.weixin.qq.com/s/jOAOd6ib15ciFADNUAWa1g",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】CMU材料科学与工程offer+1！祝贺世毕盟学员！！！",
                    "link": "https://mp.weixin.qq.com/s/UmUyVZCPmJBF5wjYmcj4yQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】双offer齐至！成功拿下CMU商业分析硕士录取！",
                    "link": "https://mp.weixin.qq.com/s/V2_spGkWbb58RY4lydkIqA",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】计算机牛校：9枚CMU ECE Offer！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/HmO6WQbjdkc8hQKlxSO3qQ",
                    "serial_number": 9
                },
                {
                    "title": "【捷报】CMU计算生物学offer收入囊中！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/X7K7Cibp4ZtHH_EZAVT3ng",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】棒！世毕盟学员喜提CMU信息科技硕士Offer！",
                    "link": "https://mp.weixin.qq.com/s/BW7bVyjj3u0LqfJzoJaIHg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】计算机天花板：CMU MSCS 录取来了！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/BZOjtTJjx-CKIphA88vTGQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】双响炮！恭喜两位学员收获CMU MSR Offer！",
                    "link": "https://mp.weixin.qq.com/s/IMKjPkTcvC6gI2MhxpFHLQ",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】CMU MSSM Offer+2，祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/uIpFMiV15CVrWpS1OyMHJA",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】重磅！7名学员斩获CMU商业智能与数据分析硕士offer！",
                    "link": "https://mp.weixin.qq.com/s/39XETS_0ZDFJWjlLysyqWQ",
                    "serial_number": 7
                },
                {
                    "title": "【捷报】交互设计王牌项目！CMU METALS！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/iAzYiqalDwKJLIZ5qrOyUw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】喜报连连！2位学员成功拿下CMU MRSD项目录取！",
                    "link": "https://mp.weixin.qq.com/s/x0y2Z0lCBgk6HRWHjsJ-hg",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】计算机名校！CMU  MITS硕士录取+2！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/YF0u-ZUCSLM_OFgUBXP_oA",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】真棒！恭喜2名学员斩获CMU MIISR offer！",
                    "link": "https://mp.weixin.qq.com/s/6se3B6rS5ihqcVdqid1rdw",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】CMU AIE双杀！恭喜两位学员成功上岸！",
                    "link": "https://mp.weixin.qq.com/s/sNsLULzXdCJkmq4mZTleow",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】CMU MSPPM-DA+1，祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/4_XRNy2hgCbszIL6eBbWVw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】CMU工学院王牌项目，CMU AIE-IS录取到！",
                    "link": "https://mp.weixin.qq.com/s/wbkx5VhIxg8x36h8cszJbg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】太好了！CMU科学数据分析硕士（MS-DAS）再添2枚录取！",
                    "link": "https://mp.weixin.qq.com/s/rvRtwwqy3d5BLIBzUbcULA",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】恭喜恭喜！CMU-MSE SS录取来了！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/a5KqawioqLjfpPpIAFFcBg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】计算机强校CMU 机器人硕士录取，WL转正！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/TQMRsEQa0t4FiEF2ys_mSQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】去硅谷！CMU软件工程录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/mtwZy9xM72YJMrnb9KBsqw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】热门物联网方向！CMU MITE录取+1！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/fkEhQrmkcSCPcGXK3sHPHA",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】定量生物学与生物信息学硕士Offer到手！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/O9zDjrAa75oW4eeF-vm4Fw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】有书读啦！CMU BIDA录取+1！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/gY2MlXBegLoQsx7EtVRoQQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】CMU人工智能工程硕士（ME方向）录取到手！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/iorCD9RRzmISm5LzTt_PrA",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】王牌项目再+1！CMU MCDS！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/SWBLqf-9Lz031NzUsfjXvQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】Waitlist转正！斩获CMU MSE-SS录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/kPd3M85d4WXnwphoEISMsw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】商业分析王牌项目！CMU BIDA录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/EmYu7lO_RH2XK7oE0MtuBw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】转正！CS四大名校：CMU机器人方向录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/CU_wOr-B0EHH2-byv_gNDg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】“计算机圣殿”CMU MITS项目录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/S1TMT3yxdcldl6upCHpZCg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】Waitlist转正！CMU商业分析硕士来啦！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/uvBzq-syeDxriKE69Awuqg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】申请季圆满！CMU管理学录取到！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/inzXJGpXgPQDaTlPvh2yCg",
                    "serial_number": 1
                },
                {
                    "title": "美帝CS四大，全奖博士offer！2026见！",
                    "link": "https://mp.weixin.qq.com/s/5gKwyRYjeWHa_8_Qkwaw2A",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】王牌项目！CMU BIDA来啦！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/vtCioLR778RbtgtT97GtwQ",
                    "serial_number": 1
                }
            ]
        },
        "Oxford": {
            cate: "Oxford",
            count: "10",
            image: "20220708071402.jpg",
            list: [
                {
                    "title": "爆：牛津大学商学院offer，2026入学！！！",
                    "link": "https://mp.weixin.qq.com/s/NQn-EwzbaFqZhDt8HbP2bw",
                    "serial_number": 1
                },
                {
                    "title": "爆：半夜发给我，牛津大学热门offer！2026入学！！！",
                    "link": "https://mp.weixin.qq.com/s/NHRwq3b_dFsheSexgVxEog",
                    "serial_number": 1
                },
                {
                    "title": "【牛津大学】热门offer抵达！2026入学！",
                    "link": "https://mp.weixin.qq.com/s/vVZGlIH_r9Hw-1xuga4xew",
                    "serial_number": 1
                },
                {
                    "title": "从211出发，斩获26年秋季牛津博士offer！",
                    "link": "https://mp.weixin.qq.com/s/bh0YiS4XEtnhKh7WQoJwyA",
                    "serial_number": 1
                },
                {
                    "title": "差点漏了，牛津大学offer，2026入学！",
                    "link": "https://mp.weixin.qq.com/s/bPBdrPDPB8_x9L7OCL2ccA",
                    "serial_number": 1
                },
                {
                    "title": "花儿都谢了：牛津大学offer来啦！",
                    "link": "https://mp.weixin.qq.com/s/hq3kkW3-qP13VGxge_I_-g",
                    "serial_number": 1
                },
                {
                    "title": "这是offer？牛津大学金融数学，没错！！！",
                    "link": "https://mp.weixin.qq.com/s/-X5yJKy212mF5b8SMGs6KA",
                    "serial_number": 1
                },
                {
                    "title": "莫名其妙：居然收到牛津大学offer！",
                    "link": "https://mp.weixin.qq.com/s/s5a9IrYI-GDyJBsTwWx8Xw",
                    "serial_number": 1
                },
                {
                    "title": "平淡无奇，牛津大学CS录取！2026！",
                    "link": "https://mp.weixin.qq.com/s/2rOSelsmZ_Z_9yKPKSoOBQ",
                    "serial_number": 1
                },
                {
                    "title": "没错，Oxford金融经济offer抵达！2026！",
                    "link": "https://mp.weixin.qq.com/s/YYksN0fora9wWEf1-4msnA",
                    "serial_number": 1
                }
            ]
        },
        "Cambridge": {
            cate: "Cambridge",
            count: "9",
            image: "20220404074729.jpg",
            list: [
                {
                    "title": "火热：剑桥大学热门offer，康桥见！",
                    "link": "https://mp.weixin.qq.com/s/CJOZ9nGdY3YlTWAfu8KSvg",
                    "serial_number": 1
                },
                {
                    "title": "从211到【剑桥大学】！offer来啦！",
                    "link": "https://mp.weixin.qq.com/s/z8QDuuTDS8439WWfuneK1w",
                    "serial_number": 1
                },
                {
                    "title": "剑桥大学经济学offer，来自西部985！",
                    "link": "https://mp.weixin.qq.com/s/DGPPNT_lXno7eSUJdmIL0A",
                    "serial_number": 1
                },
                {
                    "title": "剑桥大学金融经济，来自上纽大！2026！",
                    "link": "https://mp.weixin.qq.com/s/K5GHeMbNwNaL57XzjpzPxw",
                    "serial_number": 1
                },
                {
                    "title": "哈佛耶鲁牛津后，【剑桥大学】offer来了！2026！",
                    "link": "https://mp.weixin.qq.com/s/jpfoTIldWMPVMYZFrIUiLw",
                    "serial_number": 1
                },
                {
                    "title": "剑桥大学王牌offer，来自【中外合作办学】！",
                    "link": "https://mp.weixin.qq.com/s/DGmk7utUebDh_hO9TYb6MA",
                    "serial_number": 1
                },
                {
                    "title": "剑桥Offer也来了！但是我不去了！",
                    "link": "https://mp.weixin.qq.com/s/8eN30-Mlx6BendjIzgNKyg",
                    "serial_number": 1
                },
                {
                    "title": "剑桥热门项目录取！祝贺港本的同学！",
                    "link": "https://mp.weixin.qq.com/s/QPLZo--CL-D-P_rKGraf1g",
                    "serial_number": 1
                },
                {
                    "title": "牛津和LSE之后，剑桥大学offer也来啦！",
                    "link": "https://mp.weixin.qq.com/s/HZS2yVAKxW1bqrsb2hI0TQ",
                    "serial_number": 1
                }
            ]
        }
    },
    fiveOfferData: {
        "Yale": {
            cate: "Yale",
            count: "37",
            image: "20220514120604.png",
            list: [{
                "title": "爆：耶鲁大学offer！2026夏，纽黑文，我来啦！",
                "link": "https://mp.weixin.qq.com/s/Rt2Dmw2kRqKZNaBmylxyCg",
                "serial_number": 1
            }, {
                "title": "哭了，耶鲁大学offer，凌晨4点来信！2026入学！",
                "link": "https://mp.weixin.qq.com/s/iYHtbIVwrNCRnE-V7CNYUQ",
                "serial_number": 1
            }, {
                "title": "很刺激！凌晨4点：耶鲁大学offer来啦！",
                "link": "https://mp.weixin.qq.com/s/G914SNc3vW4jDySETD4r2Q",
                "serial_number": 1
            }, {
                "title": "一睁眼：耶鲁大学，全奖offer来啦！2026，纽黑文见！",
                "link": "https://mp.weixin.qq.com/s/dRHvpbVQsx7HfU_Aw6jNPg",
                "serial_number": 1
            }, {
                "title": "火热：耶鲁大学医学院offer！相约纽黑文！",
                "link": "https://mp.weixin.qq.com/s/sFWaNqVPh3R7FOknbml3bQ",
                "serial_number": 1
            }, {
                "title": "很平常：耶鲁大学全奖offer来啦！！！",
                "link": "https://mp.weixin.qq.com/s/9fClD_FXm2eXrK5-ah9bLQ",
                "serial_number": 1
            }, {
                "title": "耶鲁大学全奖offer，来自武汉大学！！！",
                "link": "https://mp.weixin.qq.com/s/alH3fXAOILy5TdkOs0v5Ew",
                "serial_number": 1
            }, {
                "title": "Yale统计与数据科学offer，2026纽黑文见！",
                "link": "https://mp.weixin.qq.com/s/S2LkiISBT9UEa0n-TJhKCg",
                "serial_number": 1
            }, {
                "title": "剑桥Offer到，但我去耶鲁商学院了！祝贺人大学姐！",
                "link": "https://mp.weixin.qq.com/s/6giYcRb2R-c7BSNm9WSdsA",
                "serial_number": 1
            }, {
                "title": "GPA中等也可以？【耶鲁大学】高难度offer来啦！",
                "link": "https://mp.weixin.qq.com/s/cv9OTsz9iNwN8P3VyJX3Hw",
                "serial_number": 1
            }, {
                "title": "0论文，耶鲁大学全奖博士offer抵达！",
                "link": "https://mp.weixin.qq.com/s/sUEqBNRISfSuKrBdnWMHqA",
                "serial_number": 1
            }, {
                "title": "耶鲁大学商学院offer，2026纽黑文见！",
                "link": "https://mp.weixin.qq.com/s/WuvgKq0dYyDlfALO2UiZcw",
                "serial_number": 1
            }, {
                "title": "哈哈哈，耶鲁大学热门offer抵达！2026！",
                "link": "https://mp.weixin.qq.com/s/J8SjNX5NrUnHdp836LHKig",
                "serial_number": 1
            }, {
                "title": "平淡无奇，耶鲁大学offer！2026！",
                "link": "https://mp.weixin.qq.com/s/yf94DCh1PrgsZyh269Vv3w",
                "serial_number": 1
            }, {
                "title": "耶鲁大学offer，来自上海！",
                "link": "https://mp.weixin.qq.com/s/WaQjZEjftCbIh1M18HGQPg",
                "serial_number": 1
            }, {
                "title": "转专业申请，耶鲁大学offer来啦！2026！",
                "link": "https://mp.weixin.qq.com/s/zk4QGcbrqdAz7XQ_CTsJUw",
                "serial_number": 1
            }, {
                "title": "从211出发，耶鲁大学offer来啦！2026！",
                "link": "https://mp.weixin.qq.com/s/lE_4g83vHR7_Zu6XtB45xg",
                "serial_number": 1
            }, {
                "title": "没错！耶鲁大学，商学院Offer！2026秋季见！",
                "link": "https://mp.weixin.qq.com/s/1wmW69KvL16uylM_QUxdIg",
                "serial_number": 1
              }, {
                "title": "耶鲁大学商学院！纽黑文，我来啦！",
                "link": "https://mp.weixin.qq.com/s/AHN_88scKdCrSh02HLiywg",
                "serial_number": 1
              }, {
                "title": "无敌了，耶鲁大学offer也来啦！2026！",
                "link": "https://mp.weixin.qq.com/s/bbG6kvHBns9NMpC50LH9sA",
                "serial_number": 1
              }, {
                "title": "录取率低于5%，耶鲁大学，我来啦！！！！",
                "link": "https://mp.weixin.qq.com/s/QTNbVZlUmpg_f-jOeSV5aQ",
                "serial_number": 1
              }, {
                "title": "哈佛之后，耶鲁offer也到了！来自中国昆山！",
                "link": "https://mp.weixin.qq.com/s/NdVUgBeRjgtBzhhiczPg-Q",
                "serial_number": 1
              }, {
                "title": "哈佛之后，耶鲁也到了！祝贺人民大学的同学！",
                "link": "https://mp.weixin.qq.com/s/xwbFIU1SCMWgSKcx8Ole0Q",
                "serial_number": 1
              }, {
                "title": "还是放弃了：耶鲁大学AM offer！2026！",
                "link": "https://mp.weixin.qq.com/s/3rQ2qI6nI2blHtIRZI72ig",
                "serial_number": 1
              },{
                "title": "常规操作：耶鲁大学CS offer！2026！",
                "link": "https://mp.weixin.qq.com/s/6R86lznRUVWL3LefcVIOJg",
                "serial_number": 1
              },{
                "title": "哈哈哈，耶鲁大学offer抵达！2026秋天见！",
                "link": "https://mp.weixin.qq.com/s/BjsTcErhy2nuzQLwvq8vGw",
                "serial_number": 1
              },{
                "title": "没错，2026耶鲁大学offer！热门！",
                "link": "https://mp.weixin.qq.com/s/KMHj6_8YUB2Z5w_exIyPAg",
                "serial_number": 1
              }, {
                "title": "耶鲁大学offer，来自【中国澳门】！",
                "link": "https://mp.weixin.qq.com/s/vSf1WvWt4T6pcetSh7C8dA",
                "serial_number": 1
              }, {
                "title": "GPA 3.2，耶鲁大学offer来啦！2026！",
                "link": "https://mp.weixin.qq.com/s/GlXKznHHrfFaSQG6_cK9Mw",
                "serial_number": 1
              }, {
                "title": "【耶鲁大学】数据科学全奖博士offer，来自【上纽大】！",
                "link": "https://mp.weixin.qq.com/s/jSYihhpCNDDcZrWPLeCdMg",
                "serial_number": 1
              }, {
                "title": "GPA中游，耶鲁大学offer来啦！2026！",
                "link": "https://mp.weixin.qq.com/s/0Vmwheu6qHufzYJw4Ps1ag",
                "serial_number": 1
              }, {
                "title": "重磅Offer到手！斩获耶鲁商学院录取，来自【美本】",
                "link": "https://mp.weixin.qq.com/s/IH32bhZreDfjZwVHsf_Xww",
                "serial_number": 1
              }, {
                "title": "四月才来？耶鲁大学offer！2026！",
                "link": "https://mp.weixin.qq.com/s/pyAWCxZq2foU35VXyO2ogg",
                "serial_number": 1
              }, {
                "title": "【捷报】恭喜！耶鲁大学生物统计学offer+1！祝贺世毕盟学员！",
                "link": "https://mp.weixin.qq.com/s/NuLq9HedDYkx1wl6yRhbbg",
                "serial_number": 1
              }, {
                "title": "耶鲁大学热门offer，来自NYU！",
                "link": "https://mp.weixin.qq.com/s/ejGxnLRtxZhp5xuJXIvf6w",
                "serial_number": 1
              }, {
                "title": "犹豫了，耶鲁大学offer也来啦。。。",
                "link": "https://mp.weixin.qq.com/s/dnIzTZty4qZLS40t8MD39A",
                "serial_number": 1
              }, {
                "title": "梦想成真：耶鲁大学录取！2026！",
                "link": "https://mp.weixin.qq.com/s/K50SzxzQEJb59J7BmlsE9w",
                "serial_number": 1
              }
        ]
        },
        "CMU": {
            cate: "CMU",
            count: "98",
            image: "20220615102052.jpg",
            list: [
                {
                    "title": "热门：四大神校的offer到啦！2026入学！！！",
                    "link": "https://mp.weixin.qq.com/s/9JqlI4k3JBeY07BNEpwzgg",
                    "serial_number": 1
                },
                {
                    "title": "梦想：CMU录取！四大真的来了！2026入学！",
                    "link": "https://mp.weixin.qq.com/s/wUJ3ig8PSyKyzJNo1IjnFQ",
                    "serial_number": 1
                },
                {
                    "title": "高薪就业神器：CMU MCDS，五学员集体斩获！！！",
                    "link": "https://mp.weixin.qq.com/s/aoT387F88TzZyeqw73sOKQ",
                    "serial_number": 5
                },
                {
                    "title": "【捷报】CMU 机械工程博士全奖offer已到！恭喜海本学员！",
                    "link": "https://mp.weixin.qq.com/s/hcDh2sxUXmCxgzYryCo0sw",
                    "serial_number": 1
                },
                {
                    "title": "爆！全美Top 2商学院PhD offer今日抵达！",
                    "link": "https://mp.weixin.qq.com/s/PCTvaCPvnf6N-LCtQbwm5Q",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】高含金量热门项目！CMU 数据分析科学硕士录取来啦！",
                    "link": "https://mp.weixin.qq.com/s/IVmgHDH0PYdT8snD8Q-B4A",
                    "serial_number": 1
                },
                {
                    "title": "AI世界之巅：CMU LTI博士全奖offer抵达！！！",
                    "link": "https://mp.weixin.qq.com/s/0DZkkP8fMu8yKQQuokDkQA",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】机器人旗舰项目，CMU MSR offer来了！",
                    "link": "https://mp.weixin.qq.com/s/I0wgo-hada1CU9XZBE7WFQ",
                    "serial_number": 1
                },
                {
                    "title": "CS硕士天花板：CMU MSML，6学员集体收获！",
                    "link": "https://mp.weixin.qq.com/s/qlV9A2_Y93sVnEItPzFk_w",
                    "serial_number": 6
                },
                {
                    "title": "【捷报】CMU医疗交叉学科录取+1，恭喜美本学员！",
                    "link": "https://mp.weixin.qq.com/s/_U6ByNboPMA_Bb5r66wlBg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】机器人旗舰项目，CMU MSR offer再+2！",
                    "link": "https://mp.weixin.qq.com/s/CZuyCNyt69W1HsqkX1-EIQ",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】CMU商业智能与数据分析硕士！祝贺人大学员！",
                    "link": "https://mp.weixin.qq.com/s/bhBmcG250ZHlLYND4TE2iA",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】牛！CMU ECE录取到手！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/KAH3OIlIKu10h1XiR5XIkw",
                    "serial_number": 1
                },
                {
                    "title": "金工天花板：CMU MSCF，9学员集体斩获！！！",
                    "link": "https://mp.weixin.qq.com/s/gkYQCsThmJXEiytrPtI8Zw",
                    "serial_number": 9
                },
                {
                    "title": "【捷报】牛！CMU人工智能工程录取到手！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/WAdVDdKdRkTtzZfFjO6WEw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】恭喜！CMU BIDA录取+5！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/s4QcJxYJRFXiwzYRUY5RCg",
                    "serial_number": 5
                },
                {
                    "title": "【捷报】双录CMU！两名世毕盟学员斩获机械工程硕士offer！",
                    "link": "https://mp.weixin.qq.com/s/faSFy0aLEXfcKaE3Q1RlKQ",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】好消息！CMU MSPPM 录取来啦！",
                    "link": "https://mp.weixin.qq.com/s/bn8JNmAOfSYWpQpvAGLuGQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】实力见证！CMU哲学PhD Offer来了！",
                    "link": "https://mp.weixin.qq.com/s/H-BPwYkcO00OLF_XOKoWCQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】再添一枚：CMU王牌AI工程项目录取！",
                    "link": "https://mp.weixin.qq.com/s/jOAOd6ib15ciFADNUAWa1g",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】CMU材料科学与工程offer+1！祝贺世毕盟学员！！！",
                    "link": "https://mp.weixin.qq.com/s/UmUyVZCPmJBF5wjYmcj4yQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】双offer齐至！成功拿下CMU商业分析硕士录取！",
                    "link": "https://mp.weixin.qq.com/s/V2_spGkWbb58RY4lydkIqA",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】计算机牛校：9枚CMU ECE Offer！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/HmO6WQbjdkc8hQKlxSO3qQ",
                    "serial_number": 9
                },
                {
                    "title": "【捷报】CMU计算生物学offer收入囊中！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/X7K7Cibp4ZtHH_EZAVT3ng",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】棒！世毕盟学员喜提CMU信息科技硕士Offer！",
                    "link": "https://mp.weixin.qq.com/s/BW7bVyjj3u0LqfJzoJaIHg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】计算机天花板：CMU MSCS 录取来了！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/BZOjtTJjx-CKIphA88vTGQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】双响炮！恭喜两位学员收获CMU MSR Offer！",
                    "link": "https://mp.weixin.qq.com/s/IMKjPkTcvC6gI2MhxpFHLQ",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】CMU MSSM Offer+2，祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/uIpFMiV15CVrWpS1OyMHJA",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】重磅！7名学员斩获CMU商业智能与数据分析硕士offer！",
                    "link": "https://mp.weixin.qq.com/s/39XETS_0ZDFJWjlLysyqWQ",
                    "serial_number": 7
                },
                {
                    "title": "【捷报】交互设计王牌项目！CMU METALS！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/iAzYiqalDwKJLIZ5qrOyUw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】喜报连连！2位学员成功拿下CMU MRSD项目录取！",
                    "link": "https://mp.weixin.qq.com/s/x0y2Z0lCBgk6HRWHjsJ-hg",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】计算机名校！CMU  MITS硕士录取+2！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/YF0u-ZUCSLM_OFgUBXP_oA",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】真棒！恭喜2名学员斩获CMU MIISR offer！",
                    "link": "https://mp.weixin.qq.com/s/6se3B6rS5ihqcVdqid1rdw",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】CMU AIE双杀！恭喜两位学员成功上岸！",
                    "link": "https://mp.weixin.qq.com/s/sNsLULzXdCJkmq4mZTleow",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】CMU MSPPM-DA+1，祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/4_XRNy2hgCbszIL6eBbWVw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】CMU工学院王牌项目，CMU AIE-IS录取到！",
                    "link": "https://mp.weixin.qq.com/s/wbkx5VhIxg8x36h8cszJbg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】太好了！CMU科学数据分析硕士（MS-DAS）再添2枚录取！",
                    "link": "https://mp.weixin.qq.com/s/rvRtwwqy3d5BLIBzUbcULA",
                    "serial_number": 2
                },
                {
                    "title": "【捷报】恭喜恭喜！CMU-MSE SS录取来了！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/a5KqawioqLjfpPpIAFFcBg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】计算机强校CMU 机器人硕士录取，WL转正！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/TQMRsEQa0t4FiEF2ys_mSQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】去硅谷！CMU软件工程录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/mtwZy9xM72YJMrnb9KBsqw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】热门物联网方向！CMU MITE录取+1！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/fkEhQrmkcSCPcGXK3sHPHA",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】定量生物学与生物信息学硕士Offer到手！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/O9zDjrAa75oW4eeF-vm4Fw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】有书读啦！CMU BIDA录取+1！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/gY2MlXBegLoQsx7EtVRoQQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】CMU人工智能工程硕士（ME方向）录取到手！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/iorCD9RRzmISm5LzTt_PrA",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】王牌项目再+1！CMU MCDS！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/SWBLqf-9Lz031NzUsfjXvQ",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】Waitlist转正！斩获CMU MSE-SS录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/kPd3M85d4WXnwphoEISMsw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】商业分析王牌项目！CMU BIDA录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/EmYu7lO_RH2XK7oE0MtuBw",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】转正！CS四大名校：CMU机器人方向录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/CU_wOr-B0EHH2-byv_gNDg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】“计算机圣殿”CMU MITS项目录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/S1TMT3yxdcldl6upCHpZCg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】Waitlist转正！CMU商业分析硕士来啦！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/uvBzq-syeDxriKE69Awuqg",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】申请季圆满！CMU管理学录取到！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/inzXJGpXgPQDaTlPvh2yCg",
                    "serial_number": 1
                },
                {
                    "title": "美帝CS四大，全奖博士offer！2026见！",
                    "link": "https://mp.weixin.qq.com/s/5gKwyRYjeWHa_8_Qkwaw2A",
                    "serial_number": 1
                },
                {
                    "title": "【捷报】王牌项目！CMU BIDA来啦！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/vtCioLR778RbtgtT97GtwQ",
                    "serial_number": 1
                }
            ]
        },
        "LSE": {
            cate: "LSE",
            count: "100+",
            image: "",
            list: []
        },
        "IC": {
            cate: "IC",
            count: "100+",
            image: "",
            list: []
        },
        "UCL": {
            cate: "UCL",
            count: "100+",
            image: "",
            list: []
        }
    }
}